import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserModuleOutput } from 'infrastructure/graphql/content/user/model/user-module.output';
import { UserModule } from 'user/user-module';
import { UserModuleAnswersGeneratedLinkedinProposition } from 'user/user-module-answers-generated-linkedin-proposition';
import { UserModulePage } from 'user/user-module-page';

@Injectable({ providedIn: 'root' })
export class UserModuleConverterService {
	public userModuleAsEntity(output: UserModuleOutput): UserModule {
		if (!output) {
			return null;
		}

		return new UserModule(
			output.userId,
			output.isDone,
			output.module != null ? output.module.id : output.moduleId,
			output.isStarted,
			output.coachComment,
			output.moduleRatingComment,
			output.moduleRatingValue,
			(output.pages || []).map(
				(page) => new UserModulePage(page.pageId, page.activityUrl)
			),
			output.updateTimestamp,
			output.isDescriptionVisualized,
			output.generatedUserModuleSynthesis,
			output.generatedUserModulePitch,
			output.generatedUserModulePushSynthesis,
			output.generatedUserModulePushQuestionsSynthesis,
			(output.generatedUserModuleLinkedinProposition || []).map(
				(proposition) =>
					new UserModuleAnswersGeneratedLinkedinProposition(
						proposition.value,
						proposition.sectionName
					)
			)
		);
	}

	public userModulesAsEntities(outputs: UserModuleOutput[]): UserModule[] {
		return reject(outputs, isNil).map((output) =>
			this.userModuleAsEntity(output)
		);
	}
}
